import * as React from "react";
import { GitCallouts } from "~/areas/projects/components/VersionControl/GitCallouts";
import type { ProjectPageLayoutProps } from "../../ProjectPageLayout";
import { ProjectPageLayout } from "../../ProjectPageLayout";
export const ProjectContextPaperLayout: React.FC<ProjectPageLayoutProps> = ({ children, ...rest }) => (<ProjectPageLayout {...rest} callout={<GitCallouts />}>
        {children}
    </ProjectPageLayout>);
ProjectContextPaperLayout.displayName = "ProjectContextPaperLayout"
